<script setup lang="ts">
import LogoComp from '@/components/utils/LogoComp.vue'
import codingSvg from '@/assets/images/svg/AuthOnboarding/coding.svg'

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  highlighertext: {
    type: String,
    required: true
  },
  logo: {
    type: String,
    required: false
  }
})
/**
 *
 * @param text take take string value
 * @param highlighertext take highlight value which need to be highlighted
 * @returns return modified text with highlighted text in different color
 */
const applyStyling = (text: string, highlighertext: string): string => {
  const regex = new RegExp(highlighertext, 'g')
  return text.replace(regex, `<span class="color-secondary-700" >${highlighertext}</span>`)
}

const renderText = applyStyling(props.text, props.highlighertext)
</script>

<template>
  <div :class="{ 'flex flex-col gap-20': logo }">
    <div class="flex h-[20%] w-full justify-center p-5">
      <div class="flex h-[31px] w-[144px] items-center justify-center">
        <LogoComp :isLoginModal="true" :blackLogo="true" />
      </div>
    </div>
    <div class="flex min-h-[473px] min-w-[440px] flex-col items-center justify-center p-5">
      <img :src="logo ? logo : codingSvg" class="h-[70%] w-[70%]" alt="JDroid" />
      <div class="flex flex-row gap-1">
        <span class="font-bold" v-html="renderText"></span>
        <h1 class="font-bold"></h1>
      </div>
    </div>
  </div>
</template>
